import script from "./VerPedido.vue?vue&type=script&setup=true&lang=js"
export * from "./VerPedido.vue?vue&type=script&setup=true&lang=js"

import "./VerPedido.vue?vue&type=style&index=0&id=ae53f174&lang=css"

const __exports__ = script;

export default __exports__